import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-report-sidenav",
  templateUrl: "./report-sidenav.component.html",
})
export class ReportSidenavComponent implements OnInit {
  selectedlang: any = {};
  tcCode = "";
  testCenterName = "";
  currentURL: any = "";
  constructor(private router: Router, private appservice: AppService) {}

  countryCode = "";
  ngOnInit() {
    this.countryCode = localStorage.getItem("country_code");

    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode").toString();
    }

    if (localStorage.getItem("testCenterName") != null) {
      this.testCenterName = localStorage.getItem("testCenterName");
    }

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("schedule-appointment");
    }
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }
}
